<!--
 * @Descripttion: 我的购物车页面组件
 * @Author: congz
 * @Date: 2020-06-04 11:22:40
 * @LastEditors: congz
 * @LastEditTime: 2020-08-17 10:55:06
--> 


<template>
  <div class="shoppingCart">
    <!-- 购物车头部 -->
    <div class="top-header">
      <div class="cart-header">
        <div class="logo">
          <router-link to="/">
            <img src="../assets/imgs/clogo.png" alt />
          </router-link>
        </div>
        <div class="cart-header-content">
          <p>Shopping Cart</p>
          <span>Kind reminder: Whether the product has been successfully purchased depends on the final order placed. Please settle as soon as possible</span>
        </div>
        <div class="cart-header-right">
          <div class="cart-header-select">
            <el-dropdown>
              <router-link to class="href">
                <span style="margin-right:5px">{{this.$store.getters.getUser.nickname}}</span>
                <i class="el-icon-caret-bottom"></i>
              </router-link>
              <el-dropdown-menu slot="dropdown">
                <router-link to="/">
                  <el-dropdown-item class="dropdown-menu">Home</el-dropdown-item>
                </router-link>
                <router-link to="/center">
                  <el-dropdown-item class="dropdown-menu">Personal Center</el-dropdown-item>
                </router-link>
                <router-link to="/">
                  <el-dropdown-item class="dropdown-menu">Evaluate</el-dropdown-item>
                </router-link>
                <router-link to="/favorite">
                  <el-dropdown-item class="dropdown-menu">My Collection</el-dropdown-item>
                </router-link>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="cart-header-order">
            <span>|</span>
            <router-link to="/order" class="href">My Order</router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- 购物车头部END -->

    <!-- 购物车主要内容区 -->
    <div class="cart-content" v-if="getShoppingCart.length>0">
      <ul>
        <!-- 购物车表头 -->
        <li class="content-header">
          <div class="pro-check">
            <el-checkbox v-model="isAllCheck">ALL</el-checkbox>
          </div>
          <div class="pro-img"></div>
          <div class="pro-name">Product Name</div>
          <div class="pro-size">Size</div>
          <div class="pro-price">Unit Price</div>
          <div class="pro-num">Quantity</div>
          <div class="pro-total">Subtotal</div>
          <div class="pro-action">Operation</div>
        </li>
        <!-- 购物车表头END -->

        <!-- 购物车列表 -->
        <li class="product-list" v-for="(item,index) in getShoppingCart" :key="item.id">
          <div class="pro-check">
            <el-checkbox :value="item.check" @change="checkChange($event,index)"></el-checkbox>
          </div>
          <div class="pro-img">
            <router-link :to="{ path: '/goods/details', query: {productID:item.product_id} }">
              <img :src="item.img_path" />
            </router-link>
          </div>
          <div class="pro-name">
            <router-link
              :to="{ path: '/goods/details', query: {productID:item.product_id} }"
            >{{item.name}}</router-link>
          </div>
          <div class="pro-size">{{ item.size || '-' }}</div>
          <div class="pro-price">{{item.discount_price}}₹</div>
          <div class="pro-num">
            <el-input-number
              size="small"
              :value="item.num"
              @change="handleChange($event,index,item.product_id,item.size)"
              :min="1"
              :max="item.max_num"
            ></el-input-number>
          </div>
          <div class="pro-total pro-total-in">{{item.discount_price*item.num}}₹</div>
          <div class="pro-action">
            <el-popover placement="right">
              <p>Are you sure you want to delete? </p>
              <div style="text-align: right; margin: 10px 0 0">
                <el-button
                  type="primary"
                  size="mini"
                  @click="deleteItem($event,item.id,item.product_id,item.size)"
                >Yes</el-button>
              </div>
              <i class="el-icon-error" slot="reference" style="font-size: 18px"></i>
            </el-popover>
          </div>
        </li>
        <!-- 购物车列表END -->
      </ul>
      <div style="height:20px;background-color: #f5f5f5"></div>
      <!-- 购物车底部导航条 -->
      <div class="cart-bar">
        <div class="cart-bar-left">
          <span>
            <router-link to="/goods">CONTINUE SHOPPING</router-link>
          </span>
          <span class="sep">|</span>
          <span class="cart-total">
            There are a total of
            <span class="cart-total-num">{{getNum}}</span> products,of which
            <span class="cart-total-num">{{getCheckNum}}</span> have been selected
          </span>
        </div>
        <div class="cart-bar-right">
          <span>
            <span class="total-price-title">Total：</span>
            <span class="total-price">{{getTotalPrice}}₹</span>
          </span>
          <router-link :to="getCheckNum > 0 ? '/confirmOrder' : ''">
            <div :class="getCheckNum > 0 ? 'btn-primary' : 'btn-primary-disabled'">Checkout</div>
          </router-link>
        </div>
      </div>
      <!-- 购物车底部导航条END -->
    </div>
    <!-- 购物车主要内容区END -->

    <!-- 购物车为空的时候显示的内容 -->
    <div v-else class="cart-empty">
      <div class="empty">
        <div class="empty-icon">🛍️</div>
        <h2>Your shopping cart is empty!</h2>
        <p>Looks like you haven't added anything to your cart yet.</p>
        <router-link to="/goods" class="shop-now-btn">Start Shopping</router-link>
      </div>
    </div>
    <!-- 购物车为空的时候显示的内容END -->
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'
import * as cartsAPI from '@/api/carts'

export default {
  data() {
    return {}
  },
  mounted() {
    // 默认勾选所有商品
    this.checkAll(true)
  },
  methods: {
    ...mapActions(['updateShoppingCart', 'deleteShoppingCart', 'checkAll']),
    // 修改商品数量的时候调用该函数
    handleChange(currentValue, key, productID, size) {
      // 当修改数量时，默认勾选
      this.updateShoppingCart({ key: key, prop: 'check', val: true })
      // 向后端发起更新购物车的数据库信息请求
      var form = {
        user_id: this.$store.getters.getUser.id,
        product_id: productID,
        num: currentValue,
        size: size || ''
      }
      cartsAPI
        .updateCart(form)
        .then(res => {
          if (res.status === 200) {
            // 更新vuex状态
            this.updateShoppingCart({
              key: key,
              prop: 'num',
              val: currentValue
            })
          } else if (res.status === 20001) {
            //token过期，需要重新登录
            this.loginExpired(res.msg)
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
    },
    checkChange(val, key) {
      // 更新vuex中购物车商品是否勾选的状态
      this.updateShoppingCart({ key: key, prop: 'check', val: val })
    },
    // 向后端发起删除购物车的数据库信息请求
    deleteItem(e, id, productID, size) {
      var form = {
        user_id: this.$store.getters.getUser.id,
        product_id: productID,
        size: size || ''
      }
      cartsAPI
        .deleteCart(form)
        .then(res => {
          if (res.status === 200) {
            // 更新vuex状态
            this.deleteShoppingCart(productID, size)
            this.notifySucceed('Success')
          } else if (res.status === 20001) {
            //token过期，需要重新登录
            this.loginExpired(res.msg)
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
    }
  },
  computed: {
    ...mapGetters([
      'getShoppingCart',
      'getCheckNum',
      'getTotalPrice',
      'getNum'
    ]),
    isAllCheck: {
      get() {
        return this.$store.getters.getIsAllCheck
      },
      set(val) {
        this.checkAll(val)
      }
    }
  }
}
</script>
<style scoped>
.shoppingCart {
  background-color: #FDF8F2;
  padding-bottom: 80px;
}
/* 购物车头部CSS */
.shoppingCart .top-header {
  width: 100%;
  background: linear-gradient(135deg, #D4782F 0%, #A0522D 100%);
  margin-bottom: 30px;
}
.shoppingCart .top-header .cart-header {
  display: flex;
  height: 100px;
  margin: 0 auto;
  width: 1225px;
  position: relative;
  align-items: center;
}
.shoppingCart .top-header .cart-header .logo {
  height: 60px;
  width: 100px;
  margin-right: 24px;
}
.shoppingCart .top-header .cart-header .logo img {
  height: 60px;
}

.shoppingCart .top-header .cart-header p {
  font-size: 28px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 1px;
}
.shoppingCart .top-header .cart-header .cart-header-content span {
  color: rgba(255,255,255,0.85);
  font-size: 12px;
  height: 20px;
  line-height: 20px;
  margin-left: 15px;
}
.shoppingCart .top-header .cart-header .cart-header-right {
  display: flex;
  position: absolute;
  right: 0px;
}

.shoppingCart .top-header .cart-header .cart-header-select {
  margin-top: 0;
}

.shoppingCart .top-header .cart-header .cart-header-select .href {
  font-size: 13px;
  color: rgba(255,255,255,0.9);
}
.shoppingCart .top-header .cart-header .cart-header-select .href:hover {
  color: #ffffff;
}
.dropdown-menu:hover {
  color: #D4782F;
  background-color: #FDF8F2;
}
.shoppingCart .top-header .cart-header .cart-header-order {
  margin-top: 0;
}
.shoppingCart .top-header .cart-header .cart-header-order span {
  color: rgba(255,255,255,0.5);
  margin-left: 20px;
  margin-right: 20px;
}
.shoppingCart .top-header .cart-header .cart-header-order .href {
  font-size: 13px;
  color: rgba(255,255,255,0.9);
}
.shoppingCart .top-header .cart-header .cart-header-order .href:hover {
  color: #ffffff;
}

/* 购物车头部CSS END */

/* 购物车主要内容区CSS */
.shoppingCart .cart-content {
  width: 1225px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 18px 40px rgba(185, 54, 91, 0.08);
}

.shoppingCart .cart-content ul {
  background-color: #fff;
  color: #424242;
}
/* 购物车表头及CSS */
.shoppingCart .cart-content ul .content-header {
  height: 50px;
  padding-right: 24px;
  color: #1A1A1A;
  display: flex;
  align-items: center;
  background: #FDF8F2;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.shoppingCart .cart-content ul .product-list {
  min-height: 90px;
  padding: 16px 24px 16px 0;
  border-top: 1px solid #F0E0CC;
  display: flex;
  align-items: center;
}
.shoppingCart .cart-content ul .product-list:hover {
  background: #FDF8F2;
}
.shoppingCart .cart-content ul .pro-check {
  width: 48px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.shoppingCart .cart-content ul .pro-check .el-checkbox {
  font-size: 16px;
}
.shoppingCart .cart-content ul .pro-img {
  width: 80px;
  height: 80px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.shoppingCart .cart-content ul .pro-img img {
  height: 70px;
  width: 70px;
  border-radius: 8px;
  object-fit: cover;
}
.shoppingCart .cart-content ul .pro-name {
  flex: 1;
  min-width: 0;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.shoppingCart .cart-content ul .pro-name a {
  color: #1A1A1A;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.4;
  word-break: break-word;
}
.shoppingCart .cart-content ul .pro-name a:hover {
  color: #D4782F;
}
.shoppingCart .cart-content ul .pro-price {
  width: 110px;
  flex-shrink: 0;
  text-align: center;
  font-weight: 600;
  color: #1A1A1A;
  font-size: 14px;
}
.shoppingCart .cart-content ul .pro-size {
  width: 70px;
  flex-shrink: 0;
  text-align: center;
  font-weight: 600;
  color: #D4782F;
  font-size: 14px;
}
.shoppingCart .cart-content ul .pro-num {
  width: 120px;
  flex-shrink: 0;
  text-align: center;
}
.shoppingCart .cart-content ul .pro-total {
  width: 110px;
  flex-shrink: 0;
  text-align: right;
  padding-right: 12px;
  font-weight: 700;
  color: #D4782F;
  font-size: 15px;
}
.shoppingCart .cart-content ul .pro-action {
  width: 48px;
  flex-shrink: 0;
  text-align: center;
}
.shoppingCart .cart-content ul .pro-action i:hover {
  color: #D4782F;
}
/* 购物车表头及CSS END */

/* 购物车底部导航条CSS */
.shoppingCart .cart-bar {
  width: 1225px;
  height: 70px;
  line-height: 70px;
  background-color: #fff;
  margin-bottom: 150px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  border-radius: 0 0 20px 20px;
}
.shoppingCart .cart-bar .cart-bar-left {
  display: flex;
  align-items: center;
}
.shoppingCart .cart-bar .cart-bar-left a {
  color: #6B5B4F;
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.shoppingCart .cart-bar .cart-bar-left a:hover {
  color: #D4782F;
}
.shoppingCart .cart-bar .cart-bar-left .sep {
  color: #F0E0CC;
  margin: 0 20px;
}
.shoppingCart .cart-bar .cart-bar-left .cart-total {
  color: #6B5B4F;
  font-size: 14px;
}
.shoppingCart .cart-bar .cart-bar-left .cart-total-num {
  color: #D4782F;
  font-weight: 700;
}
.shoppingCart .cart-bar .cart-bar-right {
  display: flex;
  align-items: center;
}
.shoppingCart .cart-bar .cart-bar-right .total-price-title {
  color: #6B5B4F;
  font-size: 14px;
}
.shoppingCart .cart-bar .cart-bar-right .total-price {
  color: #D4782F;
  font-size: 28px;
  font-weight: 700;
  margin-left: 8px;
}
.shoppingCart .cart-bar .cart-bar-right .btn-primary {
  width: 200px;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  margin-left: 32px;
  background: linear-gradient(135deg, #D4782F 0%, #A0522D 100%);
  color: #fff;
  padding: 14px 0;
  border-radius: 30px;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: all 0.3s;
}
.shoppingCart .cart-bar .cart-bar-right .btn-primary-disabled {
  width: 200px;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  margin-left: 32px;
  background: #F0E0CC;
  color: #A09080;
  padding: 14px 0;
  border-radius: 30px;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.shoppingCart .cart-bar .cart-bar-right .btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(185, 54, 91, 0.4);
}
/* 购物车底部导航条CSS END */
/* 购物车主要内容区CSS END */

/* 购物车为空的时候显示的内容CSS */
.shoppingCart .cart-empty {
  width: 1225px;
  margin: 0 auto;
}
.shoppingCart .cart-empty .empty {
  height: 400px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 18px 40px rgba(185, 54, 91, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #B0A090;
}
.shoppingCart .cart-empty .empty-icon {
  font-size: 80px;
  margin-bottom: 24px;
}
.shoppingCart .cart-empty .empty h2 {
  margin: 0 0 12px;
  font-size: 28px;
  color: #1A1A1A;
  font-weight: 700;
}
.shoppingCart .cart-empty .empty p {
  margin: 0 0 24px;
  font-size: 16px;
  color: #6B5B4F;
}
.shoppingCart .cart-empty .empty .shop-now-btn {
  display: inline-block;
  padding: 14px 32px;
  background: linear-gradient(135deg, #D4782F 0%, #A0522D 100%);
  color: #fff;
  border-radius: 30px;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: all 0.3s;
}
.shoppingCart .cart-empty .empty .shop-now-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(185, 54, 91, 0.4);
}
/* 购物车为空的时候显示的内容CSS END */

/* 手机端适配 */
@media (max-width: 900px) {
  .shoppingCart {
    padding-bottom: 64px;
  }
  /* 顶部头部区域 */
  .shoppingCart .top-header {
    margin-bottom: 12px;
  }
  .shoppingCart .top-header .cart-header {
    width: 100%;
    height: auto;
    padding: 12px;
    flex-wrap: wrap;
  }
  .shoppingCart .top-header .cart-header .logo {
    width: 80px;
    height: 46px;
  }
  .shoppingCart .top-header .cart-header .logo img {
    height: 46px;
  }
  .shoppingCart .top-header .cart-header p {
    font-size: 20px;
  }
  .shoppingCart .top-header .cart-header .cart-header-content span {
    display: none;
  }
  .shoppingCart .top-header .cart-header .cart-header-right {
    display: none;
  }

  /* 主体区域 */
  .shoppingCart .cart-content,
  .shoppingCart .cart-empty {
    width: 100%;
    border-radius: 0;
  }
  .shoppingCart .cart-content ul {
    line-height: normal;
  }
  /* 隐藏表头行，使用卡片式 */
  .shoppingCart .cart-content ul .content-header {
    display: none;
  }
  .shoppingCart .cart-content ul .product-list {
    height: auto;
    padding: 12px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 12px;
  }
  .shoppingCart .cart-content ul .pro-check,
  .shoppingCart .cart-content ul .pro-img,
  .shoppingCart .cart-content ul .pro-name,
  .shoppingCart .cart-content ul .pro-size,
  .shoppingCart .cart-content ul .pro-price,
  .shoppingCart .cart-content ul .pro-num,
  .shoppingCart .cart-content ul .pro-total,
  .shoppingCart .cart-content ul .pro-action {
    float: none;
    width: auto;
    height: auto;
    text-align: left;
    padding: 0;
  }
  .shoppingCart .cart-content ul .pro-check {
    order: 0;
  }
  .shoppingCart .cart-content ul .pro-img {
    order: 1;
    width: 72px;
  }
  .shoppingCart .cart-content ul .pro-img img {
    width: 64px;
    height: 64px;
    border-radius: 8px;
  }
  .shoppingCart .cart-content ul .pro-name {
    order: 1;
    flex: 1 1 auto;
    min-width: 0;
  }
  /* 第二行信息：尺码/价格/数量/小计/操作 */
  .shoppingCart .cart-content ul .pro-size,
  .shoppingCart .cart-content ul .pro-price,
  .shoppingCart .cart-content ul .pro-num,
  .shoppingCart .cart-content ul .pro-total,
  .shoppingCart .cart-content ul .pro-action {
    order: 2;
    margin-top: 4px;
  }
  .shoppingCart .cart-content ul .pro-size { width: 20%; }
  .shoppingCart .cart-content ul .pro-price { width: 25%; }
  .shoppingCart .cart-content ul .pro-num { width: 35%; }
  .shoppingCart .cart-content ul .pro-total { width: 30%; text-align: left; }
  .shoppingCart .cart-content ul .pro-action { width: 10%; text-align: right; }

  /* 底部汇总条 */
  .shoppingCart .cart-bar {
    width: 100%;
    height: auto;
    line-height: normal;
    padding: 12px;
    flex-direction: column;
    gap: 12px;
    border-radius: 0;
  }
  .shoppingCart .cart-bar .cart-bar-left,
  .shoppingCart .cart-bar .cart-bar-right {
    float: none;
    width: 100%;
  }
  .shoppingCart .cart-bar .cart-bar-right {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    flex-wrap: nowrap;
    margin-top: 8px;
  }
  .shoppingCart .cart-bar .cart-bar-right > span {
    flex: 1 1 auto;
    min-width: 0;
  }
  .shoppingCart .cart-bar .cart-bar-right a {
    flex: 0 0 46%;
    display: block;
  }
  .shoppingCart .cart-bar .cart-bar-right .btn-primary,
  .shoppingCart .cart-bar .cart-bar-right .btn-primary-disabled {
    width: 100%;
    margin-left: 0;
    font-size: 14px;
    padding: 12px 0;
  }
  /* 空购物车 */
  .shoppingCart .cart-empty {
    padding: 24px 12px 100px;
  }
  .shoppingCart .cart-empty .empty {
    height: auto;
    margin: 0;
    padding: 40px 20px;
    background: #ffffff;
    border-radius: 16px;
    box-shadow: none;
  }
  .shoppingCart .cart-empty .empty h2 {
    font-size: 24px;
  }
  .shoppingCart .cart-empty .empty p {
    font-size: 14px;
    margin: 0 0 16px;
  }
}
</style>
